import { useEffect, useState } from "react";
import { Title } from "../../../../stories/Title/Title";
import { Button } from "../../../../stories/Button/Button";
import Input from "../../../../stories/Input/Input";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../utils/Enum.keys";
import { handleMUISelectEvent } from "../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import useAssetTableJson from "../../../../json/useAssetTableJson";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import Assign from "../../../../images/Assign.svg";
import { TableHeaderProps } from "../../../../utils/types";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../styles/Variables";
import NoData from "../../../../images/NoData.svg";
import { ColumnVisibilityFor } from "../../../../utils/Enum.Datagrid";

import { useNavigate } from "react-router-dom";
import { PageFor } from "../../../../utils/Enum.types";
import Close from "../../../../images/Close.svg";
import { LicenseTypes } from "../../../../utils/Enum.types";
import Navbar from "../../../common/layout/Navbar";
import useLabels from "../../../../customHooks/useLabels";

const groupOptions = ["IT Equipment", "Tools and Machinery", "Softwares"];

const Data = [
  {
    code: "Code1",
    description: "CCTV Camera",
    group: "Camera",
    category: "equipment",
    sub_catg: "Laptop",
    model: "Acer-220",
    uom: "No's",
    ob: "-",
  },
];
interface Props extends NavTypeProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export interface NavTypeProps {
  NavType: LicenseTypes;
}
const ItemList = ({ NavType, setModalFlag, pageType }: Props) => {
  const { Items } = useAssetTableJson();
  const navigate = useNavigate();

  const [addModal, setAddModal] = useState(false);
  const dynamicHeaders: TableHeaderProps[] = Items.List.filter(
    (header) => header.field !== "actions" && header.field !== "ob" && header.field !== "total_asset"
  ).map((header) => ({
    headerName: header.headerName,
    field: header.field,
    headerAlign: header.headerAlign as GridAlignment,
    align: header.align as GridAlignment,
    flex: header.flex,
    hideable: header.hideable,
    cellClassName: header.cellClassName,
    renderCell: (params) => {
      if (header.field === "actions") {
        return (
          <>
            <button
              className="item-ob__tableblock--assign"
              onClick={() => setAddModal(!addModal)}
            >
              Enter OB <img src={Assign} alt="" />
            </button>
          </>
        );
      }

      return params.value;
    },
  }));
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        code: data.code,
        description: data.description,
        group: data.group,
        category: data.category,
        sub_catg: data.sub_catg,
        model: data.model,
        uom: data.uom,
        ob: data.ob,
      };
    }) || [];

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.ITEMS_LIST);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ITEMS_LIST,
      JSON.stringify(newModel)
    );
  };

  const { itemLabel } = useLabels();
  return (
    <>
      {pageType === PageFor.GENERAL && <Navbar NavType={NavType} />}
      {pageType === PageFor.GENERAL ? (
        <Title>{itemLabel} List</Title>
      ) : (
        <div className="item-ob__title">
          <Title>{itemLabel} List</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
      )}

      <div
        className={`item-ob${pageType === PageFor.GENERAL ? "" : "__modal"}`}
      >
        <div className="item-ob__select row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Group"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Sub Category"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Manufacturer"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              options={groupOptions}
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="HSN"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
        </div>
        <div className="item-ob__tableblock">
          {Data.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>

        {pageType === PageFor.GENERAL ? (
          <Button mode="back" onClick={() => navigate(-1)} />
        ) : (
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        )}
      </div>
    </>
  );
};

export default ItemList;
